module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMiIgaGVpZ2h0PSIyMiIgdmlld0JveD0iMCAwIDIyIDIyIj48ZGVmcz48c3R5bGU+LmEsLmN7ZmlsbDpub25lO30uYXtzdHJva2U6IzQ1NGE2YztzdHJva2Utd2lkdGg6MS41cHg7fS5ie3N0cm9rZTpub25lO308L3N0eWxlPjwvZGVmcz48ZyBjbGFzcz0iYSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMS41IDEuNSkiPjxjaXJjbGUgY2xhc3M9ImIiIGN4PSI5LjUiIGN5PSI5LjUiIHI9IjkuNSIvPjxjaXJjbGUgY2xhc3M9ImMiIGN4PSI5LjUiIGN5PSI5LjUiIHI9IjEwLjI1Ii8+PC9nPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/cambio-cobro/icon-circle-unselected.svg
// module id = 3swF
// module chunks = 1